import { create } from "zustand";

/** Set by CompletedOnboardingRoute from the onboarding status check, read by the billing page to explain the lock */
interface BillingLockState {
  billingLocked: boolean;
  /** Locked from the start: the email that created the workspace already used the free trial */
  trialAlreadyUsed: boolean;
  setBillingLock: (lock: { billingLocked: boolean; trialAlreadyUsed: boolean }) => void;
}

export const useBillingLockStore = create<BillingLockState>((set) => ({
  billingLocked: false,
  trialAlreadyUsed: false,
  setBillingLock: (lock) => set(lock),
}));
